(function () {
  if (window.productGalleryCarouselScriptLoaded) return;
  window.productGalleryCarouselScriptLoaded = true;

  const PRODUCT_GALLERY_CAROUSEL_SELECTOR = '.product-gallery-viewer';
  const PRODUCT_GALLERY_DESKTOP_MEDIA_QUERY = window.matchMedia('(min-width: 750px)');

  function getCarouselSlides(slider) {
    return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
  }

  function getCarouselStep() {
    return PRODUCT_GALLERY_DESKTOP_MEDIA_QUERY.matches ? 2 : 1;
  }

  function getCarouselItemOffset(slides) {
    if (slides.length < 2) return slides[0]?.clientWidth || 0;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }

  function getCarouselPageCount(slides, step) {
    if (!slides.length) return 0;
    return Math.max(1, Math.ceil(slides.length / step));
  }

  function getCarouselCurrentPage(slider, slides, step) {
    const offset = getCarouselItemOffset(slides);
    if (!offset) return 1;

    const currentIndex = Math.round(slider.scrollLeft / offset);
    const currentPage = Math.floor(currentIndex / step) + 1;

    return Math.min(getCarouselPageCount(slides, step), Math.max(1, currentPage));
  }

  function setCarouselPage(viewer, page) {
    const slider = viewer.querySelector('[id^="Slider-Gallery"]');
    const slides = getCarouselSlides(slider);
    const step = getCarouselStep();
    const targetIndex = Math.min((page - 1) * step, Math.max(slides.length - 1, 0));
    const targetSlide = slides[targetIndex];

    if (!targetSlide) return;

    viewer.setSlidePosition(targetSlide.offsetLeft);
  }

  function syncCarouselVideos(viewer) {
    const slider = viewer.querySelector('[id^="Slider-Gallery"]');
    if (!slider) return;

    const slides = getCarouselSlides(slider);
    const step = getCarouselStep();
    const currentPage = getCarouselCurrentPage(slider, slides, step);
    const firstVisibleIndex = Math.max(0, (currentPage - 1) * step);
    const visibleSlides = new Set(slides.slice(firstVisibleIndex, firstVisibleIndex + step));

    slides.forEach((slide) => {
      const deferredMedia = slide.querySelector('deferred-media');
      const templateMedia = deferredMedia?.querySelector('template')?.content?.firstElementChild;
      const inlineVideo = slide.querySelector('video');

      if (visibleSlides.has(slide)) {
        if (deferredMedia && templateMedia?.nodeName === 'VIDEO' && !deferredMedia.hasAttribute('loaded')) {
          deferredMedia.loadContent(false);
        }

        const activeVideo = slide.querySelector('video');
        if (activeVideo) {
          activeVideo.muted = true;
          activeVideo.playsInline = true;
          activeVideo.play().catch(() => {});
        }
      } else if (inlineVideo) {
        inlineVideo.pause();
      }
    });
  }

  function renderCarouselDots(viewer) {
    const slider = viewer.querySelector('[id^="Slider-Gallery"]');
    const prevButton = viewer.querySelector('button[name="previous"]');
    const nextButton = viewer.querySelector('button[name="next"]');
    const controls = viewer.querySelector('.product-gallery-controls');
    const dotsContainer = viewer.querySelector('.product-gallery-dots');

    if (!slider || !prevButton || !nextButton || !controls || !dotsContainer) return;

    const slides = getCarouselSlides(slider);
    const step = getCarouselStep();
    const pageCount = getCarouselPageCount(slides, step);
    const currentPage = getCarouselCurrentPage(slider, slides, step);

    syncCarouselVideos(viewer);

    prevButton.dataset.step = step;
    nextButton.dataset.step = step;

    dotsContainer.innerHTML = '';

    if (pageCount <= 1) {
      controls.classList.add('is-hidden');
      dotsContainer.classList.add('is-hidden');
      return;
    }

    controls.classList.remove('is-hidden');
    dotsContainer.classList.remove('is-hidden');

    for (let page = 1; page <= pageCount; page++) {
      const dotButton = document.createElement('button');
      const dot = document.createElement('span');

      dotButton.type = 'button';
      dotButton.className = 'slider-counter__link slider-counter__link--dots';
      dotButton.setAttribute('aria-label', `Ir para a imagem ${page}`);

      if (page === currentPage) {
        dotButton.classList.add('slider-counter__link--active');
        dotButton.setAttribute('aria-current', 'true');
      }

      dot.className = 'dot';
      dotButton.appendChild(dot);
      dotButton.addEventListener('click', () => setCarouselPage(viewer, page));
      dotsContainer.appendChild(dotButton);
    }
  }

  function initializeProductGalleryCarousel(root = document) {
    root.querySelectorAll(PRODUCT_GALLERY_CAROUSEL_SELECTOR).forEach((viewer) => {
      if (viewer.dataset.productGalleryCarouselInitialized === 'true') {
        renderCarouselDots(viewer);
        return;
      }

      viewer.dataset.productGalleryCarouselInitialized = 'true';

      const slider = viewer.querySelector('[id^="Slider-Gallery"]');
      if (!slider) return;

      const render = () => renderCarouselDots(viewer);
      const observer = new MutationObserver(render);

      slider.addEventListener('scroll', render, { passive: true });
      viewer.addEventListener('slideChanged', render);
      observer.observe(slider, { childList: true });

      viewer.productGalleryCarouselObserver = observer;
      render();
    });
  }

  document.addEventListener('DOMContentLoaded', () => initializeProductGalleryCarousel());
  document.addEventListener('product-info:loaded', ({ target }) => initializeProductGalleryCarousel(target));
  PRODUCT_GALLERY_DESKTOP_MEDIA_QUERY.addEventListener('change', () => initializeProductGalleryCarousel());
})();
